<template>
  <Default>
    <div class="home">
      <div class="home-bg"></div>
      <div class="home-text">
        <div>
          <p>PUNDIX</p>
          <p>AN NEW ARE BEGINS</p>
          <p>NPXS redenomination is completed on 29th March 2022. The token swap process has last for 12 months. We are grateful that the participating exchanges assist the swap process. An new era begins with PUNDIX!</p>
        </div>
      </div>
    </div>
  </Default>
</template>

<script>
import Default from '@/components/layout/Default'
// import Swap from '@/components/home/swap'

export default {
  name: 'Home',
  components: {
    Default
    // Swap
  },
  mounted() {
    console.error('not clear console')
  }
}
</script>
<style lang="scss" scoped>
.home {
  padding-top: 68px;
  padding-bottom: 128px;
  position: relative;
  z-index: 1;

  .home-bg {
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: 1;
    background-image: url("../assets/images/home/home.jpg");
    background-size: cover;
    background-position: center;
  }
  .home-text {
    position: fixed;
    left: 10vw;
    top: 0vh;
    right: 10vw;
    bottom: 0vh;
    z-index: 2;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    //div {
    //  font-size: 40px;
    //  color: white;
    //  max-width: 600px;
    //  margin: auto;
    //  background: rgba(0,0,0, .7);
    //  padding: 50px;
    //  border-radius: 40px;
    //  -webkit-backdrop-filter: saturate(180%) blur(20px);
    //  backdrop-filter: saturate(180%) blur(20px);
    //  box-shadow: 0px 40px 40px rgba(0,0,0,0.2);
    //}
    > div {
      font-size: 40px;
      color: white;
      max-width: 1024px;
      background: rgba(0,0,0, .5);
      padding: 50px;
      border-radius: 40px;
      -webkit-backdrop-filter: saturate(180%) blur(20px);
      backdrop-filter: saturate(180%) blur(20px);
      box-shadow: 0px 40px 40px rgba(0,0,0,0.2);
      >p {
        &:nth-child(1) {
          color: #ffbe12;
          font-size: 110px;
          font-weight: bold;
          line-height: 90px;
        }
        &:nth-child(2) {
          padding-bottom: 20px;
          opacity: 0.6;
          //font-variant:small-caps;
        }
      }
    }

  }
  .home-item {
    max-width: var(--content-width);
    margin-left: auto;
    margin-right: auto;

    & + .home-item {
      margin-top: 128px;
    }
  }
}
</style>
